import Vue from 'vue';
import Component from 'vue-class-component';
import draggable from 'vuedraggable'
import KEYS from '@/values/keys';
import { i18n } from '@/core/lang/core.i18n';
import { GROUP_TYPES, MEETING_STORE_ACTION,ALL_SET } from '../../values/meetings.values';
import { MEETINGS_STORE } from '../../store/meetings.store';
import { RequestMeetingFront } from '../../models/request-meeting-front.model'
import { CLASSES_STORE } from '@/classes/store/classes.store';
import { Student } from '@/meetings/models/student-front.model';
import { MAIN_MENU, MEETINGS_VARIABLES } from '@/core/values/core.values';
import { MEETING_TYPES_VALUES, _MEETINGS_STORE } from '@/meetings/values/meetings.values';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import Tools from '@/providers/tools'
import { CORE_ROUTES } from '@/core/core.router';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    draggable
  }
  })
export default class CustomizeClassGroups extends Vue {

  /* Variables */
  public sets:Array<RequestMeetingFront> = [];
  public selectedSet:RequestMeetingFront = {meetingId:-1,name:'',editable:false,type:GROUP_TYPES.MEETING_SET,classId:0};
  public className:string = 'ClassName';
  public classId:number = 0;
  public toggleGroupsObj:any = {};
  public temporalId = -1;
  public tempToggleGroupsObj:any = {};
  public clickedAddButton:boolean = false;
  public allStudents: Array<any> = [];
  public willBecomeActive: boolean = false;
  public meetingType: number = 0;

  /* Computed */
  get getStoreSets(){
    return this.$store.state.MeetingsStore.sets;
  }

  get getStoreClass(){
    return this.$store.state.MeetingsStore.currentClass;
  }

  get getStoreStudents(){
    return this.$store.dispatch(CLASSES_STORE.ACTIONS.GET_CLASS_STUDENTS_A,{classId:this.classId});
  }

  get availableStudentsToSelect(){
    let available = [];
    let found;
    this.allStudents.forEach(student => {
      found = undefined;
      found = this.selectedSet.rooms.find(group => {
        if(group.students.find(s => s.id == student.id)){
          return group;
        }
      });
      if(found == undefined){
        available.push(student);
      }
    });
    return available;
  }

  get selectedSetIndex(){
    return this.sets.findIndex(s => s.meetingId == this.selectedSet.meetingId);
  }

  get activeSetIndex(){
    return this.sets.findIndex(s => s.active == true);
  }

  get setsNamesList(){
    return this.sets.map(s => s.name);
  }

  get selectedSetGroupsNamesList(){
    return this.selectedSet.rooms.map(g => g.name);
  }

  get firstUneditableSet(){
    return this.sets.findIndex(s => s.editable == false);
  }

  get currentMeetingType(){
    switch (this.meetingType) {
      case -1:
        return MEETING_TYPES_VALUES.TOHAINA;
        break;

      case -2:
        return MEETING_TYPES_VALUES.EDUACPAD;
        break;

      case -3:
        return MEETING_TYPES_VALUES.WHITEBOARD;
        break;
      
      case -4:
          return MEETING_TYPES_VALUES.PRESENTATION_MODE;
          break;
      
      default:
        this.showGenericModal(false);
        break;
    }
  }

  set availableStudentsToSelect(s:any) {}

  get params() {
    const params: any = {};
    if(this.$route.params) {
      params.classId = this.$route.params.id;
      params.meetingId = this.$route.params.meeting;
    }
    return params;
  }

  /* Functions */
  public init(){
    this.sets = JSON.parse(JSON.stringify(this.getStoreSets));
    this.className = this.getStoreClass.className;
    this.classId = this.getStoreClass.classId;
    this.getStoreStudents.then(res => {
      this.allStudents = res.content;
      (this.$refs.EdLoading as any).hide();
    });
    this.initEmptyRooms();
    if(this.firstUneditableSet == undefined){
      this.selectedSet = this.sets.find(s => s.editable == true);
    }
    else{
      this.selectedSet = this.sets[this.firstUneditableSet];
    }
    this.initToggleGroups();
    this.reorderSets();
    this.selectedSet = this.sets.find(s => s.active);
  }

  public initToggleGroups(){
    if(this.sets.length>0){
      this.sets.forEach(set => {
        if(set.rooms){
          set.rooms.forEach(group => {
            Vue.set(this.toggleGroupsObj,group.meetingId,false);
          });
        }
      });
    }
  }

  public initEmptyRooms(){
    this.sets.map(s => {
      if(!s.rooms)
        s.rooms = [];
      s.rooms.forEach(g => {
        if(!g.students)
          g.students = [];
        return g;
      });
      return s;
    });
  }

  public reorderSets(){
    this.sets.sort((a,b) => {
      var date1 = Date.parse(a.startingDate);
      var date2 = Date.parse(b.startingDate);
      if(a.name == ALL_SET)
        return -1;
      if(a.editable == false && b.editable == true)
        return -1;
      if(b.editable == false)
        return 1;

      if(date1 > date2)
        return -1;
      else if(date1 < date2)
        return 1;
      else
        return 0;
    });
    this.sets.map(s => {
      s.rooms.sort((a,b) => {
        var date1 = Date.parse(a.startingDate);
        var date2 = Date.parse(b.startingDate);
        if(date1 > date2){
          return -1;
        }
        else{
          return 1;
        }
      });
    });
  }

  public addToToggleGroup(groupId){
    Vue.set(this.toggleGroupsObj,groupId,false);
  }

  public toggleGroup(groupId:number){
    this.toggleGroupsObj[groupId] = !this.toggleGroupsObj[groupId];
  }

  public createNewSet(){
    if(!this.clickedAddButton){
      this.clickedAddButton = true;
      let newSet = {
        name: '', 
        active: false,
        type: GROUP_TYPES.MEETING_SET,
        editable: true,
        meetingId: this.temporalId,
        meetingSetId: null,
        justCreated: true,
        groups: [],
        classId: this.classId,
        rooms:[]
      }
      this.sets.splice(2,0,newSet);
    }
    else{
      this.enterValidNameModal();
    }
  }

  public createNewGroup(){ 
    if(!this.clickedAddButton){
      this.clickedAddButton = true;
      let newGroup = {
        name: '', 
        type: GROUP_TYPES.MANUAL_GROUP,
        meetingId: this.temporalId,
        meetingSetId: this.selectedSet.meetingId,
        meetingUrls: { tohaina:'', etherpad:'', whiteboard:'' },
        justCreated: true,
        students: [],
        classId: this.classId,
        editable: true
      }
      this.sets[this.selectedSetIndex].rooms.unshift(newGroup);
    }
    else{
      this.enterValidNameModal();
    }
  }

  public changeSelectedSet(set:any){
    if(this.selectedSet.meetingId == set.meetingId){
      this.selectedSet = this.sets[this.firstUneditableSet];
    }
  }

  public changeActiveSet(set:any){
    if(set.active){
      this.sets[this.activeSetIndex].active = false;
      this.sets[this.firstUneditableSet].active = true;
      this.updateMeetingSet({ changedSet:this.sets[this.firstUneditableSet], action:MEETING_STORE_ACTION.CHANGE });
      this.selectedSet = this.sets[this.firstUneditableSet];
    }

  }

  public deleteSet(set:RequestMeetingFront, fromLabel?:boolean){
    this.changeActiveSet(set);
    this.changeSelectedSet(set);
    if(fromLabel || set.meetingId == this.temporalId)
      this.clickedAddButton = false;
    else
      this.updateMeetingSet({ changedSet:set, action:MEETING_STORE_ACTION.DELETE });
    this.sets.splice(this.sets.findIndex(s => s.meetingId == set.meetingId),1);
  }

  public deleteGroup(group:RequestMeetingFront, fromLabel?:boolean){
    if(fromLabel || group.meetingId == this.temporalId)
      this.clickedAddButton = false;
    else
      this.$store.dispatch(MEETINGS_STORE.ACTIONS.UPDATE_GROUP_A,{ changedGroup:group, action:MEETING_STORE_ACTION.DELETE });
    let indexS = this.sets.findIndex(s => s.meetingId == group.meetingSetId);
    this.sets[indexS].rooms.splice(this.sets[indexS].rooms.findIndex(g => g.meetingId == group.meetingId),1);
  }

  public openDeleteSetModal(set:any){
    if(set.rooms.length == 0){
      this.deleteSet(set);
      return;
    }
    var count = 0;
    set.rooms.forEach(group => {
      if(group.students.length > 0)
        count++;
    });
    if(count == 0){
      this.deleteSet(set);
    }
    else{
      if(set.meetingId == this.selectedSet.meetingId){
        this.$EdModal.createConfirmationModal({
          body: i18n.t('meetings.customizeGroups.removeActiveSetMsg'),
          actionText: i18n.t('meetings.customizeGroups.actionAccept'),
          action: () => this.deleteSet(set)
        });
      }
      else{
        this.$EdModal.createConfirmationModal({
          body: i18n.t('meetings.customizeGroups.deleteSetMsg1'),
          actionText: i18n.t('meetings.customizeGroups.actionAccept'),
          action: () => this.deleteSet(set)
        });
      }
    }
  }

  public openDeleteGroupModal(group:any){
    if( (group.students.length + this.availableStudentsToSelect.length == this.allStudents.length) 
      && this.selectedSet.active){
      this.$EdModal.createConfirmationModal({
        body: i18n.t('meetings.customizeGroups.removeActiveGroupMsg'),
        actionText: i18n.t('meetings.customizeGroups.actionAccept'),
        action: () => {
          this.changeActiveSet(this.selectedSet)
          this.deleteGroup(group)
        }
      });
    }
    else if(group.students.length == 0)
      this.deleteGroup(group);
    else{
      this.$EdModal.createConfirmationModal({
        body: i18n.t('meetings.customizeGroups.deleteGroupMsg1'),
        actionText: i18n.t('meetings.customizeGroups.actionAccept'),
        action: () => this.deleteGroup(group)
      });
    }
      
  }

  public draggedToGroup(e:any,groupId:number){
    if(e.added){
      if(this.selectedSet.active){
        this.$store.dispatch(MEETINGS_STORE.ACTIONS.UPDATE_STUDENT_A,
          {changedStudent:e.added.element,meetingId:groupId,meetingSetId:this.selectedSet.meetingId,action:MEETING_STORE_ACTION.ADD})
      }
      else if(this.willBecomeActive){
        (this.$refs.EdLoading as any).show();
        let request = {
          changedStudent:e.added.element,
          meetingId:groupId,
          meetingSetId:this.selectedSet.meetingId
          ,action:MEETING_STORE_ACTION.ADD
        }
        this.$store.dispatch(MEETINGS_STORE.ACTIONS.UPDATE_STUDENT_A,request).finally(() => {
          this.activateSet(this.selectedSet.meetingId).finally(() => {
            (this.$refs.EdLoading as any).hide();
          });
        });
        this.willBecomeActive = false;
      }
      
    }
  }

  public draggedFromAvailable(e:any){
    if(e.moved){
      this.toggleGroupsObj = { ...this.tempToggleGroupsObj };
    }
  }

  public openRemoveStudentModal(group:RequestMeetingFront, student:Student){
    if(this.availableStudentsToSelect.length == this.allStudents.length-1 && this.selectedSet.active){
      this.$EdModal.createConfirmationModal({
        body: i18n.t('meetings.customizeGroups.removeStudentMsg'),
        actionText: i18n.t('meetings.customizeGroups.actionAccept'),
        action: () => {
          this.removeStudent(group,student);
          this.changeActiveSet(this.selectedSet);
        }
      });
    }
    else{
      this.removeStudent(group,student);
    }
  }

  public removeStudent(group:RequestMeetingFront, student:Student){
    let indexS = this.sets.findIndex(s => s.meetingId == group.meetingSetId);
    let indexG = this.sets[indexS].rooms.findIndex(g => g.meetingId == group.meetingId);
    this.sets[indexS].rooms[indexG].students.splice(group.students.findIndex(s=>s.id == student.id),1);
    this.$store.dispatch(MEETINGS_STORE.ACTIONS.UPDATE_STUDENT_A,
      { changedStudent:student, meetingId:group.meetingId, meetingSetId:this.selectedSet.meetingId, action:MEETING_STORE_ACTION.DELETE });
  }
  
  public async activateSet(setId){
    this.sets = this.sets.map(s=>{
      if(s.meetingId != setId)
        s.active = false;
      else{
        s.active = true;
        this.updateMeetingSet({ changedSet:s,action:MEETING_STORE_ACTION.CHANGE }).then(()=>{
          (this.$refs.EdLoading as any).hide();
        });
      }
      return s;
    });
  }

  public setActiveSet(setId){
    let set = this.sets.find(s => s.meetingId == setId);
    if(set){
      if(!set.editable || (set.rooms.length>0 && set.rooms.find(g => g.students.length>0))){
        this.willBecomeActive = false;
        (this.$refs.EdLoading as any).show();
        this.activateSet(setId);
      }
      else{
        this.willBecomeActive = true;
      }
      this.selectedSet = set;
    }
  }

  public isRadioDisabled(set){
    if(!set.editable){
      return false;
    }
    else if(!set.rooms){
      return false;
    }
    else if(set.rooms.length>0 && set.rooms.find(g => g.students.length>0)){
      return false;
    }
    return true;
  }

  public changeSetName(newName:string, set:RequestMeetingFront, fromLabel?:boolean){
    var modifiedSet = { ...set };
    modifiedSet.name = newName;
    if(this.clickedAddButton){
      (this.$refs.EdLoading as any).show();
      this.clickedAddButton = false;
      this.updateMeetingSet({ changedSet:modifiedSet, action:MEETING_STORE_ACTION.ADD }).then(res => {
        let newSet = new RequestMeetingFront(res);
        newSet.rooms = [];
        this.sets = this.sets.map(s => {
          if(s.meetingId == this.temporalId)
            return newSet;
          else
            return s;
        });
        (this.$refs.EdLoading as any).hide();
      });
    }
    else{
      let shouldChange = true;
      this.sets = this.sets.map(s=>{
        if(s.meetingId == set.meetingId){
          if(s.name == newName)
            shouldChange = false;
          s = modifiedSet;
        }
        return s;
      });
      if(shouldChange) {
        this.updateMeetingSet({ changedSet:modifiedSet, action:MEETING_STORE_ACTION.CHANGE });
      }
    }
  }

  private async updateMeetingSet(args:{changedSet:any, action:MEETING_STORE_ACTION}) {
    //update meeting config
    const response = await this.$store.dispatch(MEETINGS_STORE.ACTIONS.UPDATE_SET_A, args);
    
    //once meeting config was updated then update meeting's info in user's local storage
    await this.$store.dispatch(_MEETINGS_STORE.ACTIONS.GET_ALL_ROOM_CLASSES_A);

    return response;
  }

  public changeGroupName(newName:string, group:RequestMeetingFront){
    var modifiedGroup = { ...group };
    modifiedGroup.name = newName;
    if(this.clickedAddButton){
      (this.$refs.EdLoading as any).show();
      this.clickedAddButton = false;
      this.$store.dispatch(MEETINGS_STORE.ACTIONS.UPDATE_GROUP_A,{ changedGroup:modifiedGroup, action:MEETING_STORE_ACTION.ADD }).then(res =>{
        let newGroup = new RequestMeetingFront(modifiedGroup);
        newGroup.students = [];
        newGroup.meetingId = res.meetingId;
        newGroup.justCreated = false;
        this.sets[this.selectedSetIndex].rooms = this.sets[this.selectedSetIndex].rooms.map(g => {
          if(g.meetingId == this.temporalId)
            return newGroup;
          else
            return g;
        });
        this.addToToggleGroup(res.meetingId);
        (this.$refs.EdLoading as any).hide();
      })
      
    }
    else{
      let shouldChange = true;
      this.sets[this.selectedSetIndex].rooms = this.sets[this.selectedSetIndex].rooms.map(g => {
        if(g.meetingId == group.meetingId){
          if(g.name == newName)
            shouldChange = false;
          g = modifiedGroup;
        }
        return g;
      });
      if(shouldChange)
        this.$store.dispatch(MEETINGS_STORE.ACTIONS.UPDATE_GROUP_A,{ changedGroup:modifiedGroup, action:MEETING_STORE_ACTION.CHANGE })
    }
    
  }

  public isGroupEditable(groupType:string){
    if(groupType == GROUP_TYPES.MANUAL_GROUP){
      return true;
    }
    return false
  }

  public unavailableSetName(set:RequestMeetingFront){
    setTimeout(() => {
      if(this.sets.findIndex(s => s.meetingId == set.meetingId) != -1){
        this.clickedAddButton = true;
        this.$EdModal.createMessageModal({
          title: i18n.t('meetings.customizeGroups.selectNewNameTitle'),
          body: i18n.t('meetings.customizeGroups.selectNewNameSetMsg'),
          type: KEYS.EVENT_TYPES.DANGER
        });
      }
    }, 100);
  }

  public unavailableGroupName(group:RequestMeetingFront){
    setTimeout(() => {
      if(this.selectedSet.rooms.findIndex(g => g.meetingId == group.meetingId) != -1){
        this.clickedAddButton = true;
        this.$EdModal.createMessageModal({
          title: i18n.t('meetings.customizeGroups.selectNewNameTitle'),
          body: i18n.t('meetings.customizeGroups.selectNewNameGroupMsg'),
          type: KEYS.EVENT_TYPES.DANGER
        });
      }
    }, 100);
  }

  public enterValidNameModal(){
    this.$EdModal.createMessageModal({
      title: i18n.t('meetings.customizeGroups.invalidNameTitle'),
      body: i18n.t('meetings.customizeGroups.invalidNameMsg'),
      type: KEYS.EVENT_TYPES.DANGER
    });
  }

  public studentMoved(e:any){
    if(!e.relatedContext.element){
      return;
    }
    
    let group = this.selectedSet.rooms.find(g => {
      if(g.students.find(s => e.relatedContext.element.id == s.id))
        return g;
    });
    if(group){
      this.toggleGroupsObj = { ...this.tempToggleGroupsObj };
      this.toggleGroupsObj[group.meetingId] = true;
    }
    else{
      this.toggleGroupsObj = { ...this.tempToggleGroupsObj };
    }
  }

  public startDragging(){
    this.tempToggleGroupsObj = { ...this.toggleGroupsObj };
  }

  public hoverGroup(groupId:number){
    this.toggleGroupsObj[groupId] = true;
  }

  public showGenericModal(changeRoute:boolean,body?){
    var bodyStr = body ? body : i18n.t('meetings.customizeGroups.genericError');
    var portalNav = MAIN_MENU[0].pathName;
    (this.$refs.EdLoading as any).hide();
    this.$EdModal.createMessageModal({
      title: i18n.t('meetings.customizeGroups.errorTitle'),
      body: bodyStr,
      type: KEYS.EVENT_TYPES.DANGER,
      action: () => { 
        if(changeRoute) 
          window.location.href = portalNav;
        }
    });
  }

  public popupBlockedToast(){
    this.$EdToast.create({ 
      msg: `${this.$i18n.t('menu.popupBlocked')}`,
      type: TOAST_TYPES.WARNING,
      timeout: 10000,
      top: '3em'
    });
  }


  public joinMeeting(meetingId: number, classId: number) {
    const path = CORE_ROUTES.JOIN_MEETING.PATH
      .replace(':classId', classId.toString())
      .replace(':id', this.meetingType.toString())
      .replace(':meeting', meetingId.toString());

    window.location.href = path;
  }

  onMounted() {
    (this.$refs.EdLoading as any).show();
    const urlParams = this.params;
    if(!urlParams.meetingId || !urlParams.classId || urlParams.meetingId == '' || urlParams.classId == '') {
      this.showGenericModal(true);
    }
    const classId = urlParams.classId;
    this.meetingType = parseInt(urlParams.meetingId);
    this.$store.dispatch(MEETINGS_STORE.ACTIONS.GET_SETS_A,parseInt(classId)).then(() => {
      this.init();
    }).catch(err => {
      this.showGenericModal(true);
    });
  }

  @Watch('$route.params.id')
  onRouteIdChange() {
    this.onMounted();
  }

  /* Hooks */
  mounted() {
    this.onMounted();
  }
}